import React, { Fragment } from 'react';

import CTAVersionLifecycle from './CTAVersionLifecycle';
import CTAWBConversion from './CTAWBConversion';

type Props = {
  integrationId: ID;
  pollDelay?: number;
  wasConvertedFromWB: boolean;
};

function CTA(props: Props) {
  const { integrationId, wasConvertedFromWB } = props;

  return (
    <Fragment>
      <CTAVersionLifecycle integrationId={integrationId} />
      <CTAWBConversion
        integrationId={integrationId}
        wasConvertedFromWB={wasConvertedFromWB}
      />
    </Fragment>
  );
}

export default CTA;
